import { Component, ElementRef, OnInit } from '@angular/core';
import { ConfigurationControlService } from '../../services/configuration/configurationControl.service';
import { Mask, MaskService } from '../../services/mask/mask.service';
declare var $: any;

@Component({
  selector: 'app-loadingMask',
  templateUrl: './loadingMask.component.html',
  styleUrls: ['./loadingMask.component.css']
})
export class LoadingMaskComponent implements OnInit {

  constructor(private _maskService: MaskService, private elRef: ElementRef, private _configurationControlService: ConfigurationControlService) { }

  public mask: Mask = new Mask();

  ngOnInit() {
    this._maskService.getMask().subscribe((mask: Mask) => {
      this.mask = mask;
      this.mask.multisesionErrorMask && this.activateModal();
      this.verifyOverflow();
    })
  }

  verifyOverflow(): void {
    if (Object.entries(this.mask).some((mask: any) => mask[1] == true)) {
      var target = document.getElementById('superBody');
      target.style.overflow = 'hidden';
    } else {
      var target = document.getElementById('superBody');
      target.style.overflow = null;
    }
  }

  activateModal(): void {
    setTimeout(() => $('#errorAutenticacion').modal({ show: 'true' }), 0);
  }

  closeMultisesionErrorMask() {
    if (this._configurationControlService.examConfiguration.securitySumadi) {
      window.postMessage({ action: 'plexiSuspend' }, location.origin)
    }
    window.location.reload();
  }
}




